export default "/images/vendor/flag-icons/flags/1x1/za.svg?951aa5d05b9663efabbd79c46ae4f6fd";